module.exports = __webpack_public_path__ + "img/workout-notebook_B095GNPP7Y.006f6040.jpg";